import RegOfDocuments from './RegOfDocuments';
import regDocumentsSchema from './schema';

export { regDocumentsSchema };

export default RegOfDocuments;
